import { render, staticRenderFns } from "./ModalNewEditExtendPhaseTerm.vue?vue&type=template&id=68ce2324"
import script from "./ModalNewEditExtendPhaseTerm.vue?vue&type=script&lang=js"
export * from "./ModalNewEditExtendPhaseTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports